import React, { useState } from 'react';
import { Server_URL } from '../../constants/constants';
import { FaTrash } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';

function DeleteButtonById({ type, id, url, onDeleteSuccess }) {
    const [showConfirmation, setShowConfirmation] = useState(false);

    const deleteScenario = async () => {
        try {
            const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');
            const response = await fetch(`${Server_URL}${url}/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                onDeleteSuccess(id);
            } else {
                // console.error(`Failed to delete ${type} with ID ${id}`);
            }
        } catch (error) {
            // console.error(`Error deleting ${type} with ID ${id}:`, error);
        }
    };

    const handleDeleteClick = () => {
        setShowConfirmation(true);
    };

    const handleConfirmDelete = () => {
        deleteScenario();
        setShowConfirmation(false);
    };

    const handleCancelDelete = () => {
        setShowConfirmation(false);
    };

    return (
        <>
            <a title="Delete Scenario" style={{ marginLeft: '10px' }} className="btn orange-color" onClick={handleDeleteClick}>
                <FaTrash />
            </a>
            <Modal show={showConfirmation} onHide={handleCancelDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelDelete}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeleteButtonById;
